const siteLoaderTheme = {
    loader: {
        container: {
            zIndex: 2,
        },
    },
};

export default siteLoaderTheme;
